import React from "react";
import SmartLink from '../../../utils/SmartLink';

// Accesos rápidos de la página de inicio (RF05): llevan a la búsqueda ordenada
// por los criterios pedidos. El orden lo resuelve el backend (/api/search-fast)
// con los campos sort=views (más visto) y sort=created (últimos añadidos).
const HomeQuickAccess = () => {
  const accesos = [
    {
      titulo: 'Datasets más visualizados',
      texto: 'Los conjuntos de datos con más visitas del portal.',
      icon: 'fa-solid fa-eye',
      to: '/search?sort=views&sort-order=desc',
    },
    {
      titulo: 'Últimos datasets añadidos',
      texto: 'Los conjuntos de datos publicados más recientemente.',
      icon: 'fa-solid fa-clock',
      to: '/search?sort=created&sort-order=desc',
    },
  ];

  return (
    <div className="grid">
      {accesos.map((acceso) => (
        <div className="card" key={acceso.titulo}>
          <div className="card-body">
            <div className="margin-bottom">
              <p className="title title--black">
                <i className={acceso.icon} aria-hidden="true"></i>{' '}
                {acceso.titulo}
              </p>
            </div>
            <div className="margin-bottom">
              <p className="text">{acceso.texto}</p>
            </div>
            <SmartLink className="button button-primary" to={acceso.to}>
              VER LISTADO
            </SmartLink>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HomeQuickAccess;
